// Dependency of angularjs-color-picker
import tinycolor from "tinycolor2";

/**
 * Adds an eyedropper button to the panel of an angularjs-color-picker, like the native color input has.
 * Uses the browser EyeDropper API (Chrome, Edge); where it is missing, no button is added.
 * Usage: <color-picker ng-model="ctrl.color" options="ctrl.pickerOptions" color-eyedropper></color-picker>
 */
class colorEyedropperDirective {
    constructor($timeout) {
        "ngInject";
        this.restrict = "A";
        this.require = "ngModel";
        this.$timeout = $timeout;
    }

    link(scope, element, attrs, ngModel) {
        if (!("EyeDropper" in window)) {
            return;
        }
        const button = angular.element(
            "<button type=\"button\" class=\"color-picker-action color-eyedropper\" tabindex=\"-1\" title=\"Pick a color from the screen\">" +
            "<i class=\"material-icons\">colorize</i></button>"
        );
        const onClick = (event) => {
            event.preventDefault();
            new window.EyeDropper().open()
                .then((result) => {
                    // Chrome can return "rgba(...)" instead of a hex string
                    const color = tinycolor(result.sRGBHex);
                    if (color.isValid()) {
                        scope.$applyAsync(() => ngModel.$setViewValue(color.toHexString()));
                    }
                })
                // Closed with Escape
                .catch(angular.noop);
        };
        button.on("click", onClick);

        // The picker template is rendered by its own directive: wait for its panel
        this.$timeout(() => {
            const actions = element[0].querySelector(".color-picker-actions");
            if (actions) {
                angular.element(actions).append(button);
            }
        });

        scope.$on("$destroy", () => button.off("click", onClick));
    }

    static create() {
        return new colorEyedropperDirective(...arguments);
    }
}

colorEyedropperDirective.create.$inject = ["$timeout"];

export {colorEyedropperDirective};



// WEBPACK FOOTER //
// ./sources/directives/color-eyedropper.directive.js